import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueSignaturePad from 'vue-signature-pad';
import './plugins/vue-meta'
import { onAuthStateChanged, getAuth } from "firebase/auth";
 
Vue.use(VueSignaturePad);

Vue.config.productionTip = false

// new Vue({
//   router,
//   vuetify,
//   render: h => h(App)
// }).$mount('#app')

const auth = getAuth();
onAuthStateChanged(auth, () => {
    new Vue({
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
})


// firebase.auth().onAuthStateChanged(function(user) {
//   console.log(user)
//   new Vue({
//     router,
//     vuetify,
//       render: h => h(App),
//     }).$mount('#app')
//   }
// );
